import styled from 'styled-components';

export const MenuText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 19px;
  color: #333333;

  .label {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }

  .pending-porto {
    flex: 1;
  }
`;

export const ItemTextName = styled.span<{ isMain?: boolean }>`
  display: inline-block;
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;

  ${({ isMain }) => isMain && `
    max-width: 130px;
  `}
`;

export const ButtonSettingsContent = styled.div<{ width: number }>`
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #EDEDED;
  min-width: 260px;
  flex-direction: column;
  margin-top: -8px;
  box-shadow: 10px 10px 30px 0px #00000066;

  .divider {
    margin: 0;
    height: 4px;
  }

  ${({ width }) => width && `
    min-width: ${width}px !important;
  `}
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
`;

export const ButtonSwitchItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ffffff;
  color: #333333;

  span {
    font-size: 14px;
    line-height: 19px;
  }

  span.main-porto {
    color: #858585;
    display: flex;
    align-items: center;
    padding-left: 4px;
  }

  span.pending-porto {
    font-size: 11px;
    line-height: 14px;
    padding: 3px 6px;
    margin-left: 8px;
    background: #F7F7F7;
    color: #858585;
    cursor: pointer;
  }

  &:hover {
    background: #F7F7F7;
    border: 1px solid #F7F7F7;

    .active-icon {
      opacity: 0;
    }

    .rename-icon.active {
      opacity: 1;
    }
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  position: relative;
`;

export const ButtonRename = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease;

  &.active-icon {
    opacity: 1;
  }

  &.rename-icon {
    opacity: 1;
  }

  &.rename-icon.active {
    opacity: 0;
  }
`;

export const ButtonSwitchItemAction = styled(ButtonSwitchItem)`
  gap: 8px;
  justify-content: flex-start;
  cursor: pointer;
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px 6px;
  cursor: pointer;
  border-radius: 4px;
`;

export const TooltipText = styled.p`
  font-size: 13px;
  line-height: 18px;
  color: #333333;
  text-align: center;
  margin: 0;
  white-space: nowrap;
`;

export const Divider = styled.div<{height: number}>`
  background: #f1f1f1;
  width: 100%;

  height: ${(props) => props.height}px;
`;
